import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Row, Col, Form } from 'react-bootstrap';
import ExpandingTextArea from 'react-expanding-textarea';
import moment from 'moment';

// Services & Helpers
import API from 'API';
import FormHelper from 'helpers/FormHelper';
import TextHelpers from 'helpers/TextHelpers';
import Print from 'Print';

// Components
import Loader from 'components/common/Loader';
import CurrencyInput from 'components/common/CurrencyInput';

//-----------------------------------------------------------------

class EditAccountInvoiceModal extends React.Component {

    constructor(props) {
        super(props);

        this.state = {};
        this.form = new FormHelper({
            fields: {
                accountID: {
                    label: 'Account',
                    type: 'single-select',
                    blankText: '(Please Select)',
                    getOptions: () => this.state.accounts.map(a => ({ value: a.id, text: a.name })),
                    isReadOnly: () => !!this.state.accountInvoice.id
                },
                number: {
                    label: 'Number',
                    type: 'number'
                },
                dateIssued: {
                    label: 'Date Issued',
                    type: 'date'
                },
                dateDue: {
                    label: 'Date Due',
                    type: 'date'
                },
                terms: {
                    label: 'Terms'
                }
            },
            getValue: (fieldName) => this.state.accountInvoice[fieldName],
            setValue: (fieldName, value) => this.updateFields({ [fieldName]: value })
        });
    }

    open(opt) {
        return new Promise((resolve) => {
            this.resolve = resolve;
            this.setState({
                isOpen: true,
                isLoading: true,
                id: opt.id,
                accountID: opt.accountID
            }, () => {
                this.load();
            });
        });
    }

    close() {
        this.setState({ isOpen: false });
    }

    async load() {
        const { id, accountID } = this.state;
        let accounts = await API.call('head-office/list-accounts');
        accounts = accounts.filter(a => !a.isHeadOffice && !a.isBookingAgent);

        let accountInvoice;
        if (id) {
            accountInvoice = await API.call('account-invoice/get/' + id);
        } else {
            accountInvoice = {
                accountID,
                dateIssued: moment().format('YYYY-MM-DD'),
                items: []
            };
        }

        this.setState({
            isLoading: false,
            accounts,
            accountInvoice
        });
    }

    async save() {
        return new Promise(async (resolve) => {
            let { accountInvoice } = this.state;
            this.setState({ isLoading: true });
            this.changedFields = {};
            const { id } = await API.call('account-invoice/save', accountInvoice);
            this.setState({ isLoading: false });
            resolve({ action: 'save', id });
        });
    }

    async saveAndClose() {
        const result = await this.save();
        this.close();
        this.resolve(result);
    }

    updateFields(fields) {
        const accountInvoice = { ...this.state.accountInvoice };
        for (let fieldName in fields) {
            const value = fields[fieldName];
            accountInvoice[fieldName] = value;
            if (fieldName == 'items') {
                this.updateTotals(accountInvoice);
            }
        }
        this.setState({ accountInvoice });
    }

    updateItem(index, newValues) {
        const { accountInvoice } = this.state;
        const items = [...accountInvoice.items];
        const item = { ...items[index] };
        for (let fieldName in newValues) {
            const value = newValues[fieldName];
            item[fieldName] = value;
        }
        delete item.isNew;
        items[index] = item;
        this.updateFields({ items });
    }

    removeItem(index) {
        const { accountInvoice } = this.state;
        const items = [...accountInvoice.items];
        items.splice(index, 1);
        this.updateFields({ items });
    }

    updateTotals(accountInvoice) {
        accountInvoice.totalNet = 0;
        accountInvoice.totalTax = 0;
        accountInvoice.totalGross = 0;
        accountInvoice.items.forEach(aii => {
            aii.net = (Number(aii.qty) || 0) * (Number(aii.unitPriceNet) || 0);
            aii.net = Math.round(aii.net * 100) / 100;
            aii.tax = aii.net * 0.2; // TODO load from config
            aii.tax = Math.round(aii.tax * 100) / 100;
            aii.gross = aii.net + aii.tax;
            accountInvoice.totalNet += aii.net;
            accountInvoice.totalTax += aii.tax;
            accountInvoice.totalGross += aii.gross;
        });
    }

    async confirmDelete() {
        const confirm = window.confirm('Are you sure you want to delete this invoice?');
        if (confirm) {
            this.setState({ isLoading: true });
            await API.call('account-invoice/delete/' + this.state.accountInvoice.id);
            this.close();
            this.resolve({ action: 'delete' });
        }
    }

    async print() {
        this.setState({ isLoading: true });
        const { id } = await this.save();
        await Print.url('/api/account-invoice/get-pdf/' + id, {
            isInline: true
        });
        this.setState({ isLoading: false });
    }

    //--------------------------------------------------------------------------

    render() {
        const { 
            isOpen,
            isLoading,
            accountInvoice
        } = this.state;

        if (!isOpen) {
            return null;
        }
       
        return (
            <Modal show onHide={() => this.close()} className="edit-account-invoice-modal" backdrop="static">
                <form onSubmit={e => { e.stopPropagation(); e.preventDefault(); this.saveAndClose() }}>
                    {/*<Modal.Header>
                        <Modal.Title>Invoice</Modal.Title>
                    </Modal.Header>*/}
                    <Modal.Body>
                        {this.renderInner()}
                    </Modal.Body>
                    {!isLoading &&
                        <Modal.Footer>

                            <button type="button" className="btn btn-secondary me-3" onClick={() => this.close()}>
                                Cancel
                            </button>

                            {!!accountInvoice.id &&
                                <button type="button" className="btn btn-danger" onClick={() => this.confirmDelete()}>
                                    Delete
                                </button>
                            }

                            <button type="button" className="btn btn-secondary ms-auto" onClick={() => this.print()}>
                                Print
                            </button>

                            <button type="button" className="btn btn-primary" onClick={() => this.saveAndClose()}>
                                <span className="icon fa fa-check" />{' '}Save & close
                            </button>

                        </Modal.Footer>
                    }
                </form>
            </Modal>
        );
    }

    renderInner() {
        const {
            isLoading,
            accountInvoice
        } = this.state;
        const { history } = this.props;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <div className="row">

                <div className="col-md-8">

                    {this.form.render([
                        'accountID'
                    ])}

                </div>

                <div className="col-md-4">

                    {this.form.render([
                        'number'
                    ])}

                </div>

            </div>

            <div className="row">

                <div className="col-md-4">

                    {this.form.render([
                        'dateIssued'
                    ])}

                </div>

                <div className="col-md-4">

                    {this.form.render([
                        'dateDue'
                    ])}

                </div>

                <div className="col-md-4">

                    {this.form.render([
                        'terms'
                    ])}
                    
                </div>

            </div>

            {this.renderItemsTable()}

        </>);
    }

    renderItemsTable() {
        const { accountInvoice } = this.state;
        const items = accountInvoice.items.concat([
            { isNew: true }
        ]);

        const renderItem = (aii, i) => {
            return (
                <tr key={i}>
                    <td>
                        <ExpandingTextArea
                            type="text"
                            className="form-control"
                            value={aii.description}
                            onChange={e => this.updateItem(i, { description: e.target.value })}
                            placeholder={aii.isNew ? 'Start typing to add a new item...' : ''}
                        />
                    </td>
                    <td className="qty-col">
                        {!aii.isNew &&
                            <input
                                type="number"
                                step="0.01"
                                className="form-control"
                                value={aii.qty || ''}
                                onChange={e => this.updateItem(i, { qty: Number(e.target.value) })}
                            />
                        }
                    </td>
                    <td className="unit-price-net-col">
                        {!aii.isNew &&
                            <CurrencyInput
                                className="form-control"
                                value={aii.unitPriceNet || ''}
                                onValueChange={(values) => this.updateItem(i, { unitPriceNet: Number(values.value) || '' })}
                            />
                        }
                    </td>
                    <td className="net-col">
                        {!aii.isNew &&
                            TextHelpers.formatCurrency(aii.net || 0)
                        }
                    </td>
                    <td>
                        {!aii.isNew &&
                            <button type="button" className="btn btn-danger" onClick={() => this.removeItem(i)}>
                                <span className="fa fa-times" />
                            </button>
                        }
                    </td>
                </tr>
            );
        };

        return (
            <Form.Group className="form-group mb-0">
                <Form.Label>Items</Form.Label>
                
                <table className="table table-bordered account-invoice-items-table">
                    <thead>
                        <tr>
                            <th className="description-col">Description</th>
                            <th className="qty-col">Qty</th>
                            <th className="unit-price-net-col">Unit Price</th>
                            <th className="net-col">Amount</th>
                            <th className="actions-col"></th>
                        </tr>
                    </thead>
                    <tbody>
                        {items.map((aii, i) => renderItem(aii, i))}
                    </tbody>
                    <tfoot>
                        <tr>
                            <td colSpan={3}>Net</td>
                            <td className="net-col">
                                {TextHelpers.formatCurrency(accountInvoice.totalNet || 0)}
                            </td>
                            <td className="actions-col"></td>
                        </tr>
                        <tr>
                            <td colSpan={3}>VAT</td>
                            <td className="net-col">
                                {TextHelpers.formatCurrency(accountInvoice.totalTax || 0)}
                            </td>
                            <td className="actions-col"></td>
                        </tr>
                        <tr>
                            <td colSpan={3}>Gross</td>
                            <td className="net-col">
                                {TextHelpers.formatCurrency(accountInvoice.totalGross || 0)}
                            </td>
                            <td className="actions-col"></td>
                        </tr>
                    </tfoot>
                </table>
            </Form.Group>
        );
    }
}

export default EditAccountInvoiceModal;